// This file was automatically generated from render.medsHx.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.medsHx');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.button');
goog.require('el8.template.core');
goog.require('el8.template.ptdata.medOrderFills');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.medOrderThread');
goog.require('el8.template.render.medOrder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="meds-hx-content el8DialogContainer"><span id="meds-hx-single-view"><div class="el8SearchContainer el8SearchWrap"><div class="el8SearchTextWrap"><input type="text" class="el8LgText w100" name="searchMeds" /></div><button class="el8button el8Search" disabled="disabled"></button></div><div class="spacer"><a class="meds-hx-all-view-trigger el8DialogLink">&#8592; View All Meds</a></div><h4 class="meds-hx-item-title el8HeaderNoBorder"></h4><ol class="meds-hx-item" class="spacer5"></ol></span><span id="meds-hx-all-view"></span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.relatedThreadSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="meds-hx-related-section" class="spacer"><a id="meds-hx-related-trigger" class="el8DialogLink">Related Meds<span id="meds-hx-related-status" class="el8Elt">');
  el8.template.core.expandIcon(null, output);
  output.append('</span></a><div id="meds-hx-related-items" class="spacer5"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.thread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="thread-item" data-id="', soy.$$escapeHtml(opt_data.thread.id), '"><div data-id="', soy.$$escapeHtml(opt_data.thread.id), '" data-type="thread" class="thread-title-item el8ThreadSummaryContainer el8ItemHover el8LargeFontSize am-highlight">');
  el8.template.render.medsHx.threadSummary(soy.$$augmentData(opt_data.thread, {num: opt_data.num}), output);
  output.append('</div><div class="el8ThreadDetailsContainer thread-details"><ol class="meds-hx-thread-orders" data-id="', soy.$$escapeHtml(opt_data.thread.id), '">');
  var orderList28992 = opt_data.orders;
  var orderListLen28992 = orderList28992.length;
  for (var orderIndex28992 = 0; orderIndex28992 < orderListLen28992; orderIndex28992++) {
    var orderData28992 = orderList28992[orderIndex28992];
    if (orderData28992.isPrescription) {
      el8.template.render.medsHx.medOrderContent(orderData28992, output);
    } else {
      el8.template.render.medsHx.dcMedOrderContent(orderData28992, output);
    }
  }
  output.append('<li class="el8ItemDescription el8AppColor">Tx Start Date: ', (soy.$$escapeHtml(opt_data.thread.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.thread.startDate)) : ''), '</li></ol></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.threadSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actions-button el8ThreadItemActionContainer">');
  el8.template.button.feedButtonList({buttons: opt_data.buttons, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>', (opt_data.num) ? '<div class="el8LargeItemCount">' + soy.$$escapeHtml(opt_data.num) + '</div>' : '', '<div class="el8MedsSummaryDate el8MedsSummaryDateWithCountPosition">', (opt_data.isActive) ? (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(opt_data.startDate)) : '') : (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(opt_data.discontinueDate)) : ''), '</div><div class="el8MedsSummaryContent el8MedsSummaryContentWithCountPosition">');
  el8.template.ptdata.model.medOrderThread.summary(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.medOrderContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.id), '" class="med-order-item el8ThreadItemContainer"><div data-id="', soy.$$escapeHtml(opt_data.id), '" data-type="order" class="actions-trigger el8ThreadItem el8ItemHover"><div class="actions-button el8ItemButtonContainer"><button class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><div class="el8DateYrMM el8AppColor', (opt_data.latestExternalFulfillment && opt_data.latestExternalFulfillment.isCancelled) ? ' el8Strike' : '', '">', (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : ''), '</div><div class="el8ItemWithDate">');
  el8.template.ptdata.model.medOrder.medsHxSummary(soy.$$augmentData(opt_data, {hasTrigger: ! opt_data.isDocumentMed && ! opt_data.isRxDownload, displayDocumentedByDate: opt_data.isDocumentMed}), output);
  output.append('</div></div>');
  if (opt_data.details) {
    el8.template.render.medsHx.fillContent(opt_data.details, output);
  }
  output.append('</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.dcMedOrderContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.id), '" class="dc-order-item el8ThreadItemContainer"><div data-id="', soy.$$escapeHtml(opt_data.id), '" data-type="order" class="actions-trigger am-highlight el8ThreadItem el8MItemHover"><div class="actions-button el8ItemButtonContainer"><button class="el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><div class="el8DateYrMM el8AppColor">', (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : ''), '</div><div class="el8ItemWithDate">');
  el8.template.ptdata.model.dcMedOrder.feedSummary(opt_data, output);
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.fillContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.fills.length >= 1) {
    output.append('<div class="fill-content el8MedsFillContainer"><div class="fill-title el8MedsFillTitle el8StandardFontSize">Fills:<br /><a class="fill-detail-status el8SmallTextLink">details</a></div><ol class="el8MedsFill fill-summary">');
    var fList29061 = opt_data.fills;
    var fListLen29061 = fList29061.length;
    for (var fIndex29061 = 0; fIndex29061 < fListLen29061; fIndex29061++) {
      var fData29061 = fList29061[fIndex29061];
      output.append('<li class="fill-item el8MedsFillItem', (fData29061.isAlert) ? ' el8ItemAlert' : '', (fData29061.isRxDownload) ? ' el8Highlight' : '', '" data-id="', soy.$$escapeHtml(fData29061.id), '"><p>', (soy.$$escapeHtml(fData29061.lastFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(fData29061.lastFillDate)) : ''), ' ', soy.$$escapeHtml(fData29061.quantity ? '#' + fData29061.quantity : ''), '</p></li>');
    }
    output.append('</ol><ol class="fill-detail el8MedsFill" style="display:none">');
    var fList29079 = opt_data.fills;
    var fListLen29079 = fList29079.length;
    for (var fIndex29079 = 0; fIndex29079 < fListLen29079; fIndex29079++) {
      var fData29079 = fList29079[fIndex29079];
      output.append('<li class="fill-item actions-trigger el8NumberItem el8ItemHover am-highlight', (fData29079.isAlert) ? ' el8ItemAlert' : '', (fData29079.isRxDownload) ? ' el8Highlight' : '', '" data-id="', soy.$$escapeHtml(fData29079.id), '" data-type="fill"><div class="actions-button el8ItemButtonContainer"><button class="el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p>');
      el8.template.ptdata.medOrderFills.summary(fData29079, output);
      output.append('</p></li>');
    }
    output.append('</ol></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.relatedThreadsList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.permRx.length) {
    output.append('<h4 class="el8SectionHeaderNoCollapse">Permanent Rx Meds</h4><ol>');
    var tList29098 = opt_data.permRx;
    var tListLen29098 = tList29098.length;
    for (var tIndex29098 = 0; tIndex29098 < tListLen29098; tIndex29098++) {
      var tData29098 = tList29098[tIndex29098];
      el8.template.render.medsHx.thread(tData29098, output);
    }
    output.append('</ol>');
  }
  if (opt_data.permOtc.length) {
    output.append('<h4 class="el8SectionHeaderNoCollapse">Permanent OTC Meds</h4><ol>');
    var tList29105 = opt_data.permOtc;
    var tListLen29105 = tList29105.length;
    for (var tIndex29105 = 0; tIndex29105 < tListLen29105; tIndex29105++) {
      var tData29105 = tList29105[tIndex29105];
      el8.template.render.medsHx.thread(tData29105, output);
    }
    output.append('</ol>');
  }
  if (opt_data.temp.length) {
    output.append('<h4 class="el8SectionHeaderNoCollapse">Temporary Meds</h4><ol>');
    var tList29112 = opt_data.temp;
    var tListLen29112 = tList29112.length;
    for (var tIndex29112 = 0; tIndex29112 < tListLen29112; tIndex29112++) {
      var tData29112 = tList29112[tIndex29112];
      el8.template.render.medsHx.thread(tData29112, output);
    }
    output.append('</ol>');
  }
  if (opt_data.dc.length) {
    output.append('<h4 class="el8SectionHeaderNoCollapse">Discontinued Meds</h4><ol>');
    var tList29119 = opt_data.dc;
    var tListLen29119 = tList29119.length;
    for (var tIndex29119 = 0; tIndex29119 < tListLen29119; tIndex29119++) {
      var tData29119 = tList29119[tIndex29119];
      el8.template.render.medsHx.thread(tData29119, output);
    }
    output.append('</ol>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.drawerContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="meds-hx-drawer-order-details"><div class="tabbed-nav el8TabHomeSection"></div><div class="order-section el8OverflowAuto"></div><div class="refill-section el8OverflowAuto"></div></div><div id="meds-hx-drawer-merge" class="el8OverflowAuto"></div><div id="meds-hx-drawer-move-fill" class="el8OverflowAuto"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.drawerButtons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="meds-hx-drawer-btns" class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.mergeView = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 id="merge-thread-title">', soy.$$escapeHtml(opt_data.title), '</h3><form id="merge-thread-list"><h4 class="el8SectionHeaderNoCollapse">Permanent Rx Meds</h4>');
  el8.template.render.medsHx.mergeViewList({threads: opt_data.permRx, str: 'Permanent Rx', type: 'perm-rx', isRadioBtn: opt_data.isRadioBtn, showNewThreadTarget: opt_data.showNewThreadTarget}, output);
  output.append('<h4 class="el8SectionHeaderNoCollapse">Permanent OTC Meds</h4>');
  el8.template.render.medsHx.mergeViewList({threads: opt_data.permOtc, str: 'Permanent OTC', type: 'perm-otc', isRadioBtn: opt_data.isRadioBtn, showNewThreadTarget: opt_data.showNewThreadTarget}, output);
  output.append('<h4 class="el8SectionHeaderNoCollapse">Temporary Meds</h4>');
  el8.template.render.medsHx.mergeViewList({threads: opt_data.temp, str: 'Temporary', type: 'temp', isRadioBtn: opt_data.isRadioBtn, showNewThreadTarget: opt_data.showNewThreadTarget}, output);
  output.append('<h4 class="el8SectionHeaderNoCollapse">Discontinued Meds</h4>');
  el8.template.render.medsHx.mergeViewList({threads: opt_data.dc, isRadioBtn: opt_data.isRadioBtn}, output);
  output.append('</form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.mergeViewList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.threads.length > 0) {
    output.append('<ol>');
    if (opt_data.showNewThreadTarget) {
      el8.template.render.medsHx.newThreadTarget(opt_data, output);
    }
    var tList29163 = opt_data.threads;
    var tListLen29163 = tList29163.length;
    for (var tIndex29163 = 0; tIndex29163 < tListLen29163; tIndex29163++) {
      var tData29163 = tList29163[tIndex29163];
      output.append('<li class="merge-thread-target ', (tData29163.isException) ? 'el8ItemDisable' : 'el8ItemHover', '" data-id="', soy.$$escapeHtml(tData29163.id), '">', (! tData29163.isException) ? '<span class="el8ItemCheckboxWrapPosition">' + ((opt_data.isRadioBtn) ? '<input name="mergeThreadTarget" type="radio" value="' + soy.$$escapeHtml(tData29163.id) + '" />' : '<input name="mergeThreadTarget" type="checkbox" value="' + soy.$$escapeHtml(tData29163.id) + '" />') + '</span>' : '', '<div class="el8ItemCount el8ItemCountWithCheckboxPosition">', soy.$$escapeHtml(tIndex29163 + 1), '</div><div class="el8DateYrMM el8ItemWithCountCheckboxPosition">', (soy.$$escapeHtml(tData29163.startDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(tData29163.startDate)) : ''), '</div><p class="el8ItemWithDateCheckbox">');
      el8.template.ptdata.model.medOrderThread.summary(tData29163, output);
      output.append('</p></li>');
    }
    output.append('</ol>');
  } else {
    output.append('<ol>');
    if (opt_data.showNewThreadTarget) {
      el8.template.render.medsHx.newThreadTarget(opt_data, output);
    }
    output.append('</ol>');
  }
  output.append('<div class="spacer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.moveFillView = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3>', soy.$$escapeHtml(opt_data.title), '</h3><form id="move-fill-list"><ol class="spacer">');
  el8.template.render.medsHx.newOrderTarget(null, output);
  var oList29208 = opt_data.orders;
  var oListLen29208 = oList29208.length;
  for (var oIndex29208 = 0; oIndex29208 < oListLen29208; oIndex29208++) {
    var oData29208 = oList29208[oIndex29208];
    output.append('<li class="move-fill-target ', (oData29208.id == opt_data.exceptOrderId) ? 'el8ItemDisable' : 'el8ItemHover', '" data-id="', soy.$$escapeHtml(oData29208.id), '">', (! (oData29208.id == opt_data.exceptOrderId)) ? '<span class="el8ItemCheckboxWrapPosition"><input name="moveFillTarget" type="radio" value="' + soy.$$escapeHtml(oData29208.id) + '" /></span>' : '', '<div class="el8DateYrMM el8ItemWithCheckboxPosition">', (soy.$$escapeHtml(oData29208.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(oData29208.startDate)) : ''), '</div><p class="el8ItemWithDateCheckbox">');
    el8.template.ptdata.model.medOrder.orderDetailedSummary(soy.$$augmentData(oData29208, {hasTrigger: false}), output);
    output.append('</p></li>');
  }
  output.append('</ol></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.orderDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><h2 class="orderTitle">', (opt_data.order.isControlled) ? 'Controlled Substance' : 'Prescription', '</h2>');
  el8.template.render.medOrder.prescription(opt_data.order, output);
  el8.template.render.medOrder.signature(opt_data.order, output);
  if (opt_data.order.pharmacy) {
    output.append('<div class="spacer"><p class="el8AppColor">The following pharmacy was selected for ePrescription:</p>');
    el8.template.render.medOrder.pharmacy(opt_data.order.pharmacy, output);
    output.append('</div>');
  }
  if (opt_data.order.fulfillments.length > 0) {
    output.append('<div class="spacer"></div>');
    el8.template.ptdata.model.medOrder.fulfillments(soy.$$augmentData(opt_data.order, {showBadges: true}), output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.mindreaderContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer"><p class="mr-descriptionText mr-subheader el8MRHeader" data-type="perm-rx">Permanent Rx Meds</p><div class="mr-extra-section mr-subheader el8MRSection" data-type="perm-rx"></div><p class="mr-descriptionText mr-subheader el8MRHeader" data-type="perm-otc">Permanent OTC Meds</p><div class="mr-extra-section mr-subheader el8MRSection" data-type="perm-otc"></div><p class="mr-descriptionText mr-subheader el8MRHeader" data-type="temporary">Temporary Meds</p><div class="mr-extra-section mr-subheader el8MRSection" data-type="temporary"></div><p class="mr-descriptionText mr-subheader el8MRHeader" data-type="discontinued">Discontinued Meds</p><div class="mr-extra-section mr-subheader el8MRSection" data-type="discontinued"></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.mindreaderResult = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.start_date), ' ', soy.$$escapeHtml(opt_data.display_name), (opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '', '</div>');
  if (opt_data.med_names && opt_data.med_names.length) {
    output.append('<div class="el8MRDetails">Includes ');
    var mList29268 = opt_data.med_names;
    var mListLen29268 = mList29268.length;
    for (var mIndex29268 = 0; mIndex29268 < mListLen29268; mIndex29268++) {
      var mData29268 = mList29268[mIndex29268];
      output.append(soy.$$escapeHtml(mData29268), (! (mIndex29268 == mListLen29268 - 1)) ? ', ' : '');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.allThreadsView = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ItemButtonWrapRight mv5">', (el8Globals.FEATURES.PMPCheck) ? '<button type="button" class="el8button el8ItemButton check-pmp-trigger" data-amplitude-source="meds-hx-content">Check PMP</button>' : '', '<button type="button" class="el8button el8ItemButton print-meds-hx-trigger">Print Medication History</button>', (opt_data.bulkRefillEnabled) ? '<button type="button" class="el8button el8ItemButton bulk-refill-trigger">Bulk Refill</button>' : '', '</div>');
  el8.template.render.medsHx.threadList({threads: opt_data.permRx, str: 'Permanent Rx', hasActions: opt_data.hasActions, buttons: opt_data.buttons}, output);
  el8.template.render.medsHx.threadList({threads: opt_data.permOtc, str: 'Permanent OTC', hasActions: opt_data.hasActions, buttons: opt_data.buttons}, output);
  el8.template.render.medsHx.threadList({threads: opt_data.temp, str: 'Temporary', hasActions: opt_data.hasActions, buttons: opt_data.buttons}, output);
  el8.template.render.medsHx.threadList({threads: opt_data.dc, str: 'Discontinued', hasActions: opt_data.hasActions, buttons: opt_data.buttons}, output);
  if (el8Globals.FEATURES.SCRIPTv2017071) {
    el8.template.render.medsHx.threadList({threads: opt_data.canceled, str: 'Script(s) Canceled', hasActions: opt_data.hasActions, buttons: opt_data.buttons}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.threadList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h4 class="el8SectionHeaderNoCollapse">', soy.$$escapeHtml(opt_data.str), '</h4>');
  if (opt_data.threads.length > 0) {
    output.append('<ol>');
    var tList29319 = opt_data.threads;
    var tListLen29319 = tList29319.length;
    for (var tIndex29319 = 0; tIndex29319 < tListLen29319; tIndex29319++) {
      var tData29319 = tList29319[tIndex29319];
      output.append('<li class="el8ItemHover thread-item" data-id="', soy.$$escapeHtml(tData29319.id), '"><div class="actions-button el8ThreadItemActionContainer">');
      el8.template.button.feedButtonList({buttons: opt_data.buttons, feedItemId: tData29319.id}, output);
      output.append('</div><div class="el8ItemCount">', soy.$$escapeHtml(tIndex29319 + 1), '</div><div class="el8DateYrMM el8ItemWithCount">', soy.$$escapeHtml(tData29319.start_date), '</div><p class="el8ItemWithDate">');
      if (tData29319.is_rx_download) {
        el8.template.core.newTag(null, output);
      }
      output.append((opt_data.hasActions) ? '<a class="select-thread-trigger" data-id="' + soy.$$escapeHtml(tData29319.id) + '">' + soy.$$escapeHtml(tData29319.display_name) + ((tData29319.directions) ? ' ' + soy.$$escapeHtml(tData29319.directions) : '') + '</a>' : '<span class="">' + soy.$$escapeHtml(tData29319.display_name) + ((tData29319.directions) ? ' ' + soy.$$escapeHtml(tData29319.directions) : '') + '</span>', (! tData29319.is_rx_download) ? '<span class="ml5 el8SystemText">last modified on ' + (soy.$$escapeHtml(tData29319.last_modified)? el8.service.tz.soyDateTime(soy.$$escapeHtml(tData29319.last_modified)) : '') + '</span>' : '', '</p>');
      if (tData29319.med_names && tData29319.med_names.length) {
        output.append('<p class="el8ItemWithDate el8AppText">Also includes: ');
        var mList29363 = tData29319.med_names;
        var mListLen29363 = mList29363.length;
        for (var mIndex29363 = 0; mIndex29363 < mListLen29363; mIndex29363++) {
          var mData29363 = mList29363[mIndex29363];
          output.append(soy.$$escapeHtml(mData29363), (! (mIndex29363 == mListLen29363 - 1)) ? ', ' : '');
        }
        output.append('</p>');
      }
      output.append('</li>');
    }
    output.append('</ol><div class="spacer"></div>');
  } else {
    output.append('<p class="el8SectionEmpty">No medications</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.newThreadTarget = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="merge-thread-target el8ItemHover"><span class="el8ItemCheckboxWrapPosition"><input name="mergeThreadTarget" type="radio" value="', soy.$$escapeHtml(opt_data.type), '" /></span><div><p class="el8ItemWithCheckbox el8ColorText">Set As Its Own Med - ', soy.$$escapeHtml(opt_data.str), '</p></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.medsHx.newOrderTarget = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="move-fill-target el8ItemHover"><span class="el8ItemCheckboxWrapPosition"><input name="moveFillTarget" type="radio" /></span><p class="el8ItemWithCheckbox el8ColorText">Create A New Medication Order</p></li>');
  if (!opt_sb) return output.toString();
};
